import { Space } from 'component/Space'
import { ShopLogo2 } from 'feature/page/ShopLogo/ShopLogo2'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import css from './StandHeader2.module.scss'

export const StandHeader2 = observer(() => {
  const demo = useDemo()
  const { logo } = demo.product

  if (!logo) return null

  return <Space className={css.header} center>
    <ShopLogo2 logo={logo} />
  </Space>
})
